import axios from "axios";
import { loginRequest } from '../authConfig'; // Import cấu hình login
import { getIsLoggingOut } from "../authUtils";

const createAxiosInstance = (instance, accounts) => {
  const apiClient = axios.create({
    baseURL: process.env.REACT_APP_URL_BE + "/api", //"https://msteamtool.dev.dut.navia.io.vn" //"https://msteamtool.dev.dut.udn.vn/api", //"http://localhost:5234" + "/api", // "https://localhost:7058/api", // Base URL của API nội bộ
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Thêm interceptor trước khi gửi request
  apiClient.interceptors.request.use(
    async (config) => {
      if (getIsLoggingOut()) {
        console.warn("Đang trong quá trình logout, bỏ qua interceptor.");
        return config; // Không thêm token nữa
      }
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        // Thêm access token vào headers
        config.headers.Authorization = `Bearer ${response.accessToken}`;
        return config;
      } catch (error) {
        console.error("Lỗi khi lấy token:", error);
        throw error;
      }
    },
    (error) => {
      // Xử lý lỗi khi request
      return Promise.reject(error);
    }
  );

  // Thêm interceptor cho response (nếu cần)
  apiClient.interceptors.response.use(
    (response) => {
      // Xử lý dữ liệu response
      return response;
    },
    (error) => {
      console.error("Lỗi API:", error.response || error.message);
      return Promise.reject(error);
    }
  );

  return apiClient;
};

export default createAxiosInstance;
